# Transport layer. hellojs is kept ONLY for its api() machinery (path maps +
# Bearer header injection) - all 26 callers depend on it. Session acquisition
# (login/refresh) moved to api/auth-v5 (chef-style v5 auth API).
hello = require 'hellojs'
R = require 'ramda'

isMultiLevelJSON = (data) ->
  R.any R.or(R.is(Object), R.isArrayLike), R.values data

toJSON = (p) ->
  if R.is(Object, p.data) and isMultiLevelJSON(p.data)
    p.data = JSON.stringify(p.data)
    p.headers['content-type'] = 'application/json'

usersService =
  id: APP_CLIENT_ID
  name: 'users'
  scope:
    basic: 'public'
  scope_delim: ' '
  base: USERS_SERVER
  form: false
  jsonp: false
  get:
    settings: "/v1/settings.json"
    orders: "#{ORDERS_SVC}/v4/orders.json"
    restaurants: "#{CP_SVC}/restaurants.json"
    takeouts: "#{ORDERS_SVC_API5}/v5/takeouts"
    takeout_templates: "#{ORDERS_SVC_API5}/v5/takeouts/templates"
    feedbackSession: "#{FEEDBACK_SVC}/sessions/index.json"
    openReviews: "#{FEEDBACK_SVC}/feedbacks/open.json"
    seenReviews: "#{FEEDBACK_SVC}/feedbacks/seen.json"
    drivers: "#{RDSAAS_SVC}/v1/api/drivers.json"
    delivery_service: "#{RDSAAS_SVC}/v1/api/delivery_services.json"
    searchRestaurants: "#{API3_SVC}/v4/restaurants/search.json"
  post:
    takeout: "#{ORDERS_SVC_API5}/v5/takeouts"
    search_users: '/v1/users/search.json'
    searchRestaurants: "#{API3_SVC}/v4/restaurants/search.json"
    searchRestaurantsV5: "#{RESTAURANTS_SVC_API5}/v6/restaurants/search"
  put:
    settings: "/v1/settings.json"
  xhr: (p, qs) ->
    makeBaseAuth = (user, password) ->
      tok = user + ':' + password
      hash = btoa tok
      "Basic #{hash}"
    p.headers['OAUTH_VERSION'] = 'v2' # for CP
    if p.method is "post" or p.method is 'put'
      toJSON(p)
    if p.path == "orders"
      p.headers['Authorization'] = makeBaseAuth 'zuppler', 'api'
    token = qs.access_token
    delete qs.access_token
    p.headers.Authorization = "Bearer #{token}"
    true

hello.init { users: usersService }, {}

# Seeds hellojs' localStorage session store so client.api() attaches the
# Bearer token and getAuthResponse() keeps working for all existing callers.
# expires must be epoch SECONDS (hellojs compares against now/1000).
# No refresh_token here: hellojs' monitor would try its dead OAuth refresh on
# expiry - refresh is handled by stores/user via the v5 API instead.
seedSession = (user) ->
  hello.utils.store 'users',
    access_token: user.oauth_token
    expires: user.token_expires_at
    network: 'users'

clearSession = ->
  hello.utils.store 'users', null

client = hello 'users'
client.seedSession = seedSession
client.clearSession = clearSession

module.exports = client